export default {
    CaPayment: 0, 
    CaPaymentTwo: 1, 
    CaPaymentMLNS: 2,
    CaPaymentA5: 3,
    CaPaymentA5A4: 4, 
  };